import Vue from 'vue'
import CustomPlanApi from '../apis/custom_plan'
export const state = () => ({
  id: "",
  monthly_imp_limit: 4_000_000,
  heatmap_imp_limit: 4_000_000,
  amount: 0,
  lists: [],
  coupon_code: '',
});
export const actions = {
  async create({ commit, state }, params) {
    return await CustomPlanApi.create({
      monthly_imp_limit: params.monthly_imp_limit,
      heatmap_imp_limit: params.monthly_heatmap_imp_limit,
      interval: params.interval,
      interval_count: params.interval_count,
      amount: state.amount,
    })
  },
  async subscribe({ commit, state }, id) {
    return await CustomPlanApi.subscribe(id, state.coupon_code)
  },
  async checkCouponExists({ commit, state }, { plan_id, coupon_code }) {
    const {data} = await CustomPlanApi.check_coupon_exists(plan_id, coupon_code)
    return data
  },
  async destroy({ commit, state }, id) {
    return await CustomPlanApi.destroy(id)
  },
}
export const mutations = {
  setId(state, id){
    state.id = id
  },
  setMontlyImpLimit(state, monthly_imp_limit){
    state.monthly_imp_limit = monthly_imp_limit
  },
  setHeatmapImpLimit(state, heatmap_imp_limit){
    state.heatmap_imp_limit = heatmap_imp_limit
  },
  setAmount(state, amount){
    state.amount = amount
  },
  setLists(state, lists){
    state.lists = lists
  },
  addList(state, list){
    state.lists.push(list)
  },
  removeList(state, id){
    state.lists = state.lists.filter((list) => {
      return list.for_json.id != id
    })
  },
  setCouponCode(state, coupon_code){
    state.coupon_code = coupon_code
  },
}
export const getters = {}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
